const RequestAddressSvg = () => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" fill="none"><circle cx="13.5" cy="13.5" r="13.5" fill="#B6BFE7"/><path fill="#fff" d="M14 7a6.007 6.007 0 0 0-6 6c0 2.441 1.772 4.469 3.65 6.615.593.68 1.208 1.382 1.756 2.093a.75.75 0 0 0 1.188 0c.548-.711 1.163-1.414 1.757-2.093C18.227 17.469 20 15.442 20 13a6.007 6.007 0 0 0-6-6Zm0 8.25a2.25 2.25 0 1 1 0-4.499 2.25 2.25 0 0 1 0 4.5Z"/></svg>
    )
}

export default RequestAddressSvg;